const counters = document.querySelectorAll('.rlt-stat-number');

const updateCount = (counter) => {
	const target = +counter.getAttribute('data-count');
	const count = +counter.innerText;

	const speed = 250;
	const increment = target / speed;

	if (count < target) {
		counter.innerText = Math.ceil(count + increment);
		setTimeout(() => updateCount(counter), 10);
	} else {
		counter.innerText = target;
	}
};

const observerOptions = {
	threshold: 1,
};

const intersectionObserver = new IntersectionObserver(
	(entries, observerInstance) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				updateCount(entry.target);
				observerInstance.unobserve(entry.target);
			}
		});
	},
	observerOptions
);

counters.forEach((counter) => {
	intersectionObserver.observe(counter);
});
